import React from 'react';
import { cn } from '@/lib/utils';
import { APP_THEMES, type AppThemeId } from '@/config/appThemes';
import { useAppTheme } from '@/hooks/useAppTheme';

export function ThemePicker() {
  const { themeId, setTheme } = useAppTheme();

  return (
    <div className="space-y-3">
      <div>
        <p className="text-sm font-medium text-foreground">Appearance</p>
        <p className="text-xs text-muted-foreground mt-0.5">
          Same UI everywhere — only lighting, accents, and texture change.
        </p>
      </div>
      <div
        className="grid grid-cols-2 gap-2.5"
        role="radiogroup"
        aria-label="App theme"
      >
        {APP_THEMES.map((theme) => {
          const selected = themeId === theme.id;

          return (
            <button
              key={theme.id}
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => setTheme(theme.id as AppThemeId)}
              className={cn(
                'relative flex flex-col rounded-lg border p-2.5 text-left transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-primary focus-visible:ring-offset-2',
                selected
                  ? 'border-accent-primary ring-1 ring-accent-primary/40'
                  : 'border-border hover:border-border-hover'
              )}
            >
              <div
                className="mb-2 h-14 w-full rounded-md overflow-hidden border border-white/10"
                style={{
                  background: theme.preview.background,
                  backgroundImage: `linear-gradient(135deg, ${theme.preview.primary}33 0%, transparent 50%), linear-gradient(225deg, ${theme.preview.accent}22 0%, transparent 45%)`,
                }}
                aria-hidden
              >
                <div className="flex h-full items-end gap-1 p-2">
                  <span
                    className="h-3 w-3 rounded-full shrink-0"
                    style={{ background: theme.preview.primary }}
                  />
                  <span
                    className="h-3 w-3 rounded-full shrink-0"
                    style={{ background: theme.preview.accent }}
                  />
                </div>
              </div>
              <span className="text-sm font-semibold text-foreground">
                {theme.emoji} {theme.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
